import PopTagBox from './poptagbox.vue';
export default PopTagBox;


// WEBPACK FOOTER //
// ./src/components/poptagbox/index.js